import { defineStore } from 'pinia'
import { useUserStore } from './user'
import { fetch, fetchUrl } from '@/lib/booking'
// import axios from 'axios'

export const useBookingStore = defineStore('booking', {
  state: () => ({
    dialog: false,
    dialogOptions: false,
    dialogData: {
      mode: '',
      type: '',
      cancelled: false,
      bookingStatus: '',
      price: '',
      currency: '',
      locator: '',
      button: true,
      details: {
        locator: '',
        shortLocator: ''
      },
      id: '',
      policies: [],
      payments: {},
      start: '',
      nights: 0,
      penalty: {
        penalty: false,
        penaltyCurrency: 'USD',
        penaltyType: '$',
        penaltyValue: 0,
        penaltyCaused: {
          type: 'no-show',
          time: 0,
          timeType: 'hours'
        }
      }
    },
    list: [],
    listLoading: false,
    pagination: {
      totalDocs: 0,
      limit: 20,
      page: 1,
      totalPages: 1,
      pagingCounter: 1,
      hasPrevPage: false,
      hasNextPage: false,
      prevPage: 0,
      nextPage: 0
    },
    filteredList: [],
    search: '',
    columns: [
      'id',
      'integrator',
      'product',
      'createdAt',
      'start',
      'status',
      'provider',
      'locator',
      'user',
      'client',
      'cost',
      'price'
    ]
  }),

  actions: {
    updateAgency(payload) {
      this.id = payload._id || ''
      this.name = payload.name || ''
      this.logo = payload.logo || ''
      this.theme = payload.theme || 'default'
      this.sandbox = payload.sandbox || 'default'
    },
    async fetch() {
      try {
        this.listLoading = true
        const user = useUserStore()
        let response = []
        let type = 'agency'
        if (user.type === 'adviser' && !user.configuration.canSeeAllVouchers) type = 'adviser'
        if (user.type === 'super') type = 'super'

        let url = fetchUrl(type, user.id)
        url += `?page=${this.pagination.page}&limit=${this.pagination.limit}`

        response = await fetch({ url })
        this.list = response.docs
        this.filteredList = response.docs
        this.pagination.totalDocs = response.totalDocs
        this.pagination.totalPages = response.totalPages
        this.pagination.hasPrevPage = response.hasPrevPage
        this.pagination.hasNextPage = response.hasNextPage
        this.pagination.prevPage = response.prevPage
        this.pagination.nextPage = response.nextPage
        this.listLoading = false
      } catch (e) {
        this.listLoading = true
      }
    },
    searchFilter() {
      const keyword = this.search.toLowerCase().trim()
      if (keyword.length < 1) {
        this.filteredList = this.list
        return
      }
      const filteredList = this.list.filter((e) => {
        if (
          e.externalBookingReference &&
          e.externalBookingReference.toLowerCase().includes(keyword)
        ) {
          return true
        }

        if (e.reservation.locator && e.reservation.locator.toLowerCase().includes(keyword)) {
          return true
        }

        if (
          e.user &&
          e.user.profile &&
          e.user.profile.name &&
          e.user.profile.name.toLowerCase().includes(keyword)
        ) {
          return true
        }
        if (e.client && e.client.name && e.client.name.toLowerCase().includes(keyword)) {
          return true
        }
        if (e.agency && e.agency.name && e.agency.name.toLowerCase().includes(keyword)) {
          return true
        }

        if (e.price && e.price.gross && e.price.gross.toLowerCase().includes(keyword)) {
          return true
        }

        if (e.payments && e.payments.client && String(e.payments.client).includes(keyword)) {
          return true
        }

        if (e.price && e.price.currency && e.price.currency.toLowerCase().includes(keyword)) {
          return true
        }

        return false
      })

      this.filteredList = filteredList
    }
  },
  persist: true
})
